function initializeInventoryDocuments() {
  document.querySelectorAll("[data-inventory-line-form]").forEach(form => {
    if (form.inventoryInitialized) return
    form.inventoryInitialized = true
    const quantity = form.querySelector("[data-inventory-quantity]")
    const preview = form.querySelector("[data-inventory-quantity-preview]")
    const update = () => {
      const value = quantity.value
      preview.textContent = quantity.validity.valid && value
        ? `Cantidad a guardar: ${value} ${Number(value) === 1 ? "unidad" : "unidades"}.`
        : "Indica una cantidad de unidades mayor que cero."
    }
    quantity.addEventListener("input", update)
    update()
  })
  document.querySelectorAll("[data-dismiss-rotation-hint]").forEach(button => {
    if (button.rotationInitialized) return
    button.rotationInitialized = true
    button.addEventListener("click", () => { button.closest("[data-rotation-hint]").hidden = true })
  })
}

document.addEventListener("DOMContentLoaded", initializeInventoryDocuments)
document.addEventListener("turbolinks:load", initializeInventoryDocuments)
